export const plMessages = {
  "form.calculation": "Kalkulacja",
  "common.datepicker.timeCaption": "Godzina",
  "common.datepicker.placeholder": "DD/MM/RRRR",
  "message.90days":
    "Masz 90 dni od daty podpisania wniosku na dokonanie wyliczeń. {breakingLine} W polach poniżej podaj dane ze złożonego wniosku.",
  "form.contributionPeriod": "Okres opłacania składki (w pełnych latach)",
  "form.choose": "wybierz",
  "form.typeAmount": "wpisz kwotę",
  "form.calculate": "Oblicz",
  "form.at": "Na",
  "form.example": "Przykład:",
  "form.assuredSum": "Wysokość gwarantowanej sumy z tytułu dożycia (w zł)",
  "form.hasErrorRequest": "Wystąpił błąd",
  "form.durationAgreement": "Okres trwania umowy (w pełnych latach)",
  "form.durationMainAgreement": "Okres trwania umowy głównej (w pełnych latach)",
  "form.annualSubscription": "Roczna składka (w zł)",
  "form.invalidDate": "Wprowadź prawidłową datę.",
  "form.calculationImpossibleMsg":
    "Niestety kalkulacja nie jest możliwa. Jeśli masz polisę, skorzystaj z portalu Klienta mojePru.",
  "form.dateOfAppSignature": "Data podpisania wniosku",
  "form.frequencyPayments": "Częstotliwość opłacania składki",
  "form.durationContract": "Okres trwania umowy głównej (w pełnych latach)",
  "form.annualCoreContract": "Roczna składka z tytułu umowy głównej (w zł)",
  "form.MainContractContribution": "Składka z tytułu umowy głównej (w zł)",
  "form.savingsProfile": "Profil oszczędzania",
  "form.nameSurance": "Nazwa ubezpieczenia",
  "form.print": "Wydrukuj",
  "table.amountIncreasingBaseValueBasic": "kwota powiększająca bazową wartość wykupu,",
  "table.amountIncreasingBaseValueDesc":
    "która będzie dodawana po upływie każdego kolejnego miesiąca ubezpieczenia, jeśli została zapłacona składka za ten miesiąc.",
  "tableContentGrayTextBox.howReadTable": "Jak czytać tabelę?",
  "table.AmountBaseRedemption":
    "Kwota powiększająca bazową wartość wykupu należną za każdy kolejny miesiąc ubezpieczenia w trakcie trwania roku ubezpieczenia",
  "table.baseRedemptionValueBasic": "bazowa wartość wykupu",
  "table.baseRedemptionValueBasicDesc":
    "czyli kwota początkowa w danym roku ubezpieczenia, o ile została zapłacona co najmniej jedna składka należna w tym roku,",
  "table.baseRedemptionValue":
    "Bazowa wartość wykupu (należna w danym roku ubezpieczenia po opłaceniu pierwszej składki za ten rok)",
  "tableContentGrayTextBox.firstText":
    "Kwota otrzymana w razie wypowiedzenia umowy przed upływem okresu ubezpieczenia  nie będzie niższa niż ",
  "tableContentGrayTextBox.firstTextBold": "gwarantowana kwota wypłaty.",
  "tableContentGrayTextBox.secondTextFirst": "Dodatkowo, do tej kwoty dodamy udział w ",
  "tableContentGrayTextBox.secondTextSecond": "premiach rocznych, ",
  "tableContentGrayTextBox.secondTextThird": " o ile w poprzednich latach zostały",
  "tableContentGrayTextBox.secondTextFour": " zadeklarowane dla danej umowy.",
  "tableContentGrayTextBox.secondTextFifth": " W ostatniej kolumnie widać jaki procent dotychczas",
  "tableContentGrayTextBox.secondTextSixth": "przyznanych premii",
  "tableContentGrayTextBox.secondTextSeventh":
    " przysługuje w poszczególnych latach w przypadku wcześniejszego wypowiedzenia umowy. ",
  "tableContentGrayTextBox.thirdText":
    "Pamiętajmy jednak, że samo przyznanie premii rocznej nie jest gwarantowane.",
  "tableContentSmallGrayTextBox.Text":
    "Pamiętaj że dane z tabeli należy odczytywać w połączeniu z ogólnymi warunkami ubezpieczenia, które wyjaśniają zasady wypłaty świadczeń w razie wypowiedzenia umowy oraz określają w jakich przypadkach wskazana kwota może nie być dostępna lub podlegać zmianom.",
  "tableContentWhiteText.firstText":
    "Prezentowane w tabeli wartości wynikają z wnioskowanych parametrów umowy.",
  "tableContentWhiteText.secondText":
    "Wysokości świadczeń z tabeli znajdują się również w polisie, jeśli umowa zostanie zawarta.",
  "tableContentWhiteText.thirdText":
    "Od drugiego roku ubezpieczenia do końca okresu opłacania składek gwarantowana wartość wykupu i gwarantowana kwota wypłaty wskazane w tabeli zostały ustalone przy założeniu, że za dany rok ubezpieczenia została opłacona składka. W przypadku nieopłacenia składki, obowiązują wartości z roku poprzedniego.",
  "tableContentWhiteText.fourthText":
    "W przypadku, gdy składka za okres niewykorzystanej ochrony przewyższa składkę zwracaną w ramach gwarantowanej kwoty wypłaty, Prudential wypłaci różnicę w ramach kwoty wypłaty.",
  "form.guaranteedSurrenderValue": "gwarantowaną wartość wykupu",
  "form.consistsofTwoAmounts": "składają się dwie kwoty:",
  "form.YearInsurance": "Rok ubezpieczenia.",
  "form.guaranteedRedemption": "Gwarantowana wartość wykupu (zł)",
  "form.guaranteedDeposit": "Gwarantowana kwota wypłaty (zł)",
  "form.CalcStillProgress": "Przepraszamy, obliczanie nadal  trwa",
  "form.noCalculationPossible": "Wykonanie obliczenia nie jest możliwe",
  "form.declaredAnnual": "Udział w zadeklarowanych premiach rocznych",
  "form.declaredAnnualAdvance":
    "Udział w zadeklarowanych premiach rocznych (należny w danym roku ubezpieczenia po opłaceniu pierwszej składki za ten rok)",
  "productCategory.INV": "PEWNY KAPITAŁ",
  "productCategory.SAV": "OSZCZĘDNOŚCI BEZ OBAW",
  "productCategory.PENS": "EMERYTURA BEZ OBAW",
  "productCategory.CHILD": "START W ŻYCIE",
  "dicts.PREMIUM_FREQUENCY.Monthly": "Miesięczna",
  "dicts.PREMIUM_FREQUENCY.Quarterly": "Kwartalna",
  "dicts.PREMIUM_FREQUENCY.Semi-Annual": "Półroczna",
  "dicts.PREMIUM_FREQUENCY.Annual": "Roczna",
  "dicts.INVESTMENT_PROFILE.CAUTIOUS": "Konserwatywny",
  "dicts.INVESTMENT_PROFILE.BALANCED": "Zrównoważony",
  "validations.sumAssuredMin": "Minimalna suma ubezpieczenia to {min}",
  "form.Empty": "Pole nie może być puste.",
  "form.minPremiumPerFreq": "Minimalna składka roczna to {min}.",
  "form.maxPremiumPerFreq": "Maksymalna składka roczna to {max}.",
  "form.minSumAssured": "Wartość gwarantowanej sumy jest za mała minimalna to: {min}.",
  "form.maxSumAssured": "Wartość gwarantowanej sumy jest za duża maksymalna to: {max}.",
  "form.minPayments":
    "Dla danego okresu trwania umowy minimalny okres opłacania składki to {min} lat.",
  "form.maxPayments":
    "Dla danego okresu trwania umowy maksymalny okres opłacania składki to {max} lat.",
  "form.maxSumPremiumPerFreq": "Suma składek {current} zł jest wyższa od maksymalnej {max} zł.",
  "form.minDefaultPremiumPerFreq":
    "Za niska składka. Najniższa możliwa to {min} dla wybranej częstotliwości.",
  "form.maxDefaultPremiumPerFreq":
    "Za wysoka składka. Najwyższa możliwa to {max} dla wybranej częstotliwości.",
  "form.minDefaultSumAssured": "Suma ubezpieczenia jest niższa niż minimalna {min}.",
  "form.maxDefaultSumAssured": "Suma ubezpieczenia jest wyższa niż maksymalna {max}.",
  "response.StandardTableExamplesFirst":
    "Załóżmy, że w ósmym roku bazowa wartość wykupu wynosi {base}, a po upływie każdego kolejnego miesiąca, po zapłaceniu składki za ten miesiąc, jej wartość wzrasta o {updatedBase}.",

  "response.StandardTableExamplesSecond":
    "Jeżeli wypowiesz umowę w połowie ósmego roku ubezpieczenia, gwarantowana kwota, którą otrzymasz wyniesie: ",
  "response.StandardTableExamplesSecondResult": "{base} + 6*{updatedBase} = {result} zł",
  "response.StandardTableExamplesThird":
    "Dodatkowo do wyliczonej wyżej gwarantowanej kwoty dodamy udział w premiach rocznych, o ile w poprzednich latach zostały one zadeklarowane dla Twojej umowy.",
  "response.StandardTableExamplesFourth":
    "W ostatniej kolumnie widzisz, jaki procent dotychczas zadeklarowanych premii rocznych przysługuje Ci w poszczególnych latach w przypadku wcześniejszego wypowiedzenia umowy.",
  "response.StandardTableExamplesFifth":
    "W naszym przykładzie załóżmy, że wypowiadając umowę w połowie ósmego roku otrzymasz dodatkowo {percent}% łącznej kwoty premii rocznych, o ile przed Twoim wypowiedzeniem były zadeklarowane dla Twojej umowy. Pamiętaj jednak, że zadeklarowanie premii rocznych nie jest gwarantowane. ",
  "tableContentStandardSmallGrayTextBox.Text":
    "Pamiętaj, że dane z tabeli należy odczytywać w połączeniu z ogólnymi warunkami ubezpieczenia, które wyjaśniają zasady wypłaty świadczeń w razie wypowiedzenia umowy oraz określają w jakich przypadkach wskazana kwota może nie być dostępna lub podlegać zmianom.",
  "tableContentStandardWhiteTextBox.TextFirst":
    "Prezentowane w tabeli wartości wynikają z wnioskowanych parametrów umowy.",
  "tableContentStandardWhiteTextBox.TextSecond":
    "Wysokości świadczeń z tabeli znajdują się również w polisie, jeśli umowa zostanie zawarta.{breakingLine} Zwracamy uwagę, że Prudential w wyniku oceny ryzyka ubezpieczeniowego może zaproponować zawarcie umowy na zmienionych warunkach.{breakingLine} Otrzymasz wówczas informację o wpływie zmian na wysokość wskazanych wartości."
};
